//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import noticeEventListVue from './component/notice-event-list.vue';
import cloudEventListVue from './component/cloud-event-list.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    noticeEventListVue,
    cloudEventListVue,
  },
  data() {
    return {
      eventTypes: 'noticeEvent',
      status: '1',
    };
  },
  computed: {
    ...mapGetters({
      appList: 'workflow/getAppList',
      moudleList: 'workflow/getBusinessModuleList',
    }),
    ...mapGetters('user', ['getElementList']), // user 模块名称
    jurisdiction() {
      const jurisdictionArray = [
        'eventManage_workflow_createCloudFunction',
        'eventManage_workflow_createNoticeEvent',
        'eventManage_workflow_editCloudFunction',
        'eventManage_workflow_enableCloudFunction',
        'eventManage_workflow_stopCloudFunction',
        'eventManage_workflow_deleteCloudFunction',
        'eventManage_workflow_deleteNoticeEvent',
        'eventManage_workflow_stopNoticeEvent',
        'eventManage_workflow_enableNoticeEvent',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
  },
  created() {
    if (this.$route.query.eventTypes) {
      this.eventTypes = this.$route.query.eventTypes;
    }
    if (this.$route.query.statusTab) {
      this.status = this.$route.query.statusTab;
    }
  },
  methods: {
    handleSelectCloudEvent() {
      this.$router.push({
        name: 'cloud-event-detail',
      });
    },
    handleCreateNoticeEvent() {
      this.$router.push({
        name: 'noitce-event-detail',
      });
    },
  },
};
